export default __webpack_public_path__ + "static/media/blog_inner_12.0e7a1460.png";